import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const EASE = [0.22, 1, 0.36, 1];

export const MaskedLine = ({ children, delay }) => (
    <span className="block overflow-hidden pb-1">
        <motion.span
            className="block"
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Corner = ({ className }) => (
    <span
        aria-hidden="true"
        className={`pointer-events-none absolute font-mono-tl text-lg text-tl-orange/70 ${className}`}
    >
        +
    </span>
);

export const HeroActions = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.8, ease: EASE }}
        className="mt-10 flex flex-col gap-4 sm:flex-row"
    >
        <button
            type="button"
            data-testid="hero-cta-primary"
            onClick={() => scrollToId("contatti")}
            className="group flex items-center justify-center gap-3 bg-tl-orange px-8 py-4 font-mono-tl text-sm font-semibold uppercase tracking-[0.15em] text-tl-dark transition-colors duration-300 hover:bg-tl-orangeHover"
        >
            Richiedi un preventivo
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
        <button
            type="button"
            data-testid="hero-cta-secondary"
            onClick={() => scrollToId("lavorazioni")}
            className="flex items-center justify-center gap-3 border border-white/25 px-8 py-4 font-mono-tl text-sm uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:border-tl-orange hover:text-tl-orange"
        >
            Scopri le nostre lavorazioni
        </button>
    </motion.div>
);

export const HeroStrip = () => (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.3, duration: 1 }}
        className="mt-16 flex flex-wrap items-center gap-x-8 gap-y-3 border-t border-white/10 pt-6 font-mono-tl text-[11px] uppercase tracking-[0.2em] text-white/50"
    >
        <span>Fresatura CNC 3 assi</span>
        <span className="text-tl-orange">/</span>
        <span>Pezzi · Stampi · Prototipi</span>
        <span className="text-tl-orange">/</span>
        <span>Ferro &amp; Alluminio</span>
        <span className="ml-auto hidden items-center gap-2 md:flex">
            Scorri
            <span className="relative block h-8 w-px overflow-hidden bg-white/15">
                <span className="animate-tl-scroll-line absolute inset-0 bg-tl-orange" />
            </span>
            <ArrowDown size={12} className="text-tl-orange" />
        </span>
    </motion.div>
);
